import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { SpanExporter, BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { trace } from '@opentelemetry/api';

// 1. Custom Exporter
class SWTraceExporter implements SpanExporter {
    export(spans:any, resultCallback:any) {
        function postToSW(message:any) {
            if (navigator.serviceWorker && navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage(message);
                resultCallback({ code: 0 });
            } else {
                setTimeout(() => postToSW(message), 500);
            }
        }
        postToSW({
            type: 'otel-spans',
            spans: spans.map((s:any) => s.toReadableSpan ? s.toReadableSpan() : s)
        });
    }
    shutdown() {
        return Promise.resolve();
    }
}

// 2. Provider with SWTraceExporter
const provider = new WebTracerProvider({
    // spanProcessors: [
    //     new BatchSpanProcessor(new SWTraceExporter())
    // ],
});

provider.register({
    contextManager: new ZoneContextManager(),
});

trace.setGlobalTracerProvider(provider);
export const tracer = trace.getTracer('website');

// 3. Instrumentations
registerInstrumentations({
    instrumentations: [
        getWebAutoInstrumentations({
            '@opentelemetry/instrumentation-document-load': {},
            '@opentelemetry/instrumentation-user-interaction': {
                enabled: true,
                eventNames: [],
            },
            '@opentelemetry/instrumentation-fetch': {
                propagateTraceHeaderCorsUrls: [/.+/g],
                ignoreUrls: [
                    /clarity\.ms\/collect/,
                    /yektanet\.com/,
                    /doubleclick\.net/,
                    /googletagmanager\.com/,
                    /analytics\.google\.com/,
                    /cdn\.iranhotelonline\.com/,
                ],
            },
            '@opentelemetry/instrumentation-xml-http-request': {
                propagateTraceHeaderCorsUrls: [/.+/g],
                ignoreUrls: [
                    /clarity\.ms\/collect/,
                    /yektanet\.com/,
                    /doubleclick\.net/,
                    /googletagmanager\.com/,
                    /analytics\.google\.com/,
                    /cdn\.iranhotelonline\.com/,
                ],
            },
        }),
    ],
});
